import { group } from "console";
import { AnaColumn } from "../forms-template.service";
import { Gruppo } from "./Gruppo";
//import { aspect } from "./aspect";
import { patternString } from "./patternString";
import { gridEditable, gridSimple, createGridConfig } from "./gridSettings/gridSettings";

const aspect = 'vw';
const aspectRatio = 7.7;


export const soggettoDetail: AnaColumn[] = []

export const soggettoTest: AnaColumn[] = []


export const soggetto: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'Anagrafiche azienda',
      titleForm: '$descrizioneSoggetto',
      breadcrumbCaption: 'Anagrafica azienda',
      campoTitle: ['descrizioneSoggetto'],
      masterKey: 'id',
      service: 'soggetto',
      api: 'soggetto',
      filterList: '?NostreAziende=$NostreAziende',
      startTemplate: 'grid',
      allowedAdvancedFilter: true,
      isAdvancedXlsExportAvailable: true,
      advancedXlsExportFilterTemplateName: 'esportaSediFiltri',
      helpDoc: 'Anagrafichepropriimpianti.html',
      queryFilter: [
        {
          key: 'idSoggetto',
          value: 'id'
        },
        {
          key: 'isConfigRentri',
          value: 'isConfigRentri'
        },
        {
          key: 'isConfigVivifir',
          value: 'isConfigVivifir'
        },
        {
          key: 'descrizioneSoggetto',
          value: 'ragioneSociale',
        },
        {
          key: 'CODFIS',
          value: 'codiceFiscale',
        },
        {
          key: 'nsAzienda',
          value: 'nsAzienda'
        },
        {
          key: 'NostreAziende',
          value: 'NostreAziende'
        },
        {
          key: 'nomeModulo',
          value: 'nomeModulo'
        },
      ],
      filterEditor: '/$',
      formType: 'simple',
      idTabRif: [

        {
          key: 'nsAzienda',
          value: 'nsAzienda'
        },

      ],
      nCol: 1,
      toolbarSettings: {
        service: 'soggetto',

      }

    }

  },

  {
    itemType: "group", groupWidth: 1000, class: 'mt-3', groupDataField: 'datiFiscali', colCount: "3", caption: "Dati Fiscali Impresa", data: [
      {
        allowFixing: true,
        type: 'campo',
        dataField: "ragioneSociale",
        caption: "Ragione Sociale",
        orderGriglia: 1,
        maxLength: '45',
        maxSize: 45,
        colVisible: true,
        colWidth: '870',
        showInColumnChooser: true, allowHiding: false,
        class: "required",
        nCol: "5",
        validation: [
          { type: "required", message: "Ragione Sociale obbligatoria" }
        ],
      },
      {
        type: 'campoButton', dataField: "codiceFiscale", colVisible: true, caption: "C.F.", dataType: "",
        showInColumnChooser: true, allowHiding: false,
        maxLength: '16',
        maxSize: 30,
        orderGriglia: 2,
        colWidth: '120',
        nCol: 25,
        labelWidth: 35,
        validation: [
          { type: "required", message: "Codice Fiscale obbligatorio" },

        ],
        button: {
          text: '',
          name: 'infoCF',
          location: 'after',
          event: "OptionalIconButtonClick",
          hint: "Ottieni le informazioni",
          icon: "glyphicon mdi mdi-file-search-outline",
          outPutValue: true,
          related: ['codiceFiscale', 'partitaIVA']
        }
      },
      { type: "empty", nCol: 2, dataField: "", colVisible: false, caption: "", dataType: "" },

      {
        type: 'campo', dataField: "estensione", caption: "Est. Rag. Sociale", colVisible: false, dataType: "",
        maxLength: '45', maxSize: 45,
        nCol: "5",
      },


      {
        type: 'campoButton', showInColumnChooser: true, dataField: "partitaIVA", colVisible: false, caption: "P.Iva", dataType: "",
        maxLength: '11', maxSize: 30,
        colWidth: '120',
        nCol: 25,
        labelWidth: 35,

        button: {
          text: '',
          name: 'infoPiva',
          location: 'after',
          event: "OptionalIconButtonClick",
          hint: "Ottieni le informazioni",
          icon: "glyphicon mdi mdi-file-search-outline",


          outPutValue: true,
          related: ['codiceFiscale', 'partitaIVA']
        }
      },
      {
        type: 'campoSpecial',
        colVisible: false,
        dataField: "isoFiscale",
        caption: "Iso",
        maxLength: '2',
        maxSize: 5,
        showInColumnChooser: false,
        disableOnUpdate: true,
        nCol: "2",
        width: 43,
        class: 'ms-3',
        validation: [
          { type: "required", message: "Iso Fiscale obbligatorio" }
        ],
        dynamic: {
          dataSource: 'StatoEstero',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'iso',
          service: 'generic',
          componentType: 'dynamicGrid',
          caption: 'Stato Estero',
          // related: ['iso|stato', 'id|istatComuneProv'],
          buttonOption: {
            text: 'isoFiscale',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Selezione Stato Estero - Iso Fiscale',
            name: 'isoFiscale',
            location: 'after',
          },
          settingGrid: gridSimple

        }


      },

      {
        type: 'campo', dataField: "alias", caption: "Alias", colVisible: false, dataType: "",
        maxLength: '45', maxSize: 45, colWidth: '120', nCol: "5",
      },

      {
        type: 'campo', showInColumnChooser: false, dataField: "titolo", caption: "Titolo", colVisible: false, dataType: "",
        maxLength: '13', maxSize: 30, nCol: "25", labelWidth: 35
      },
      { type: "empty", nCol: 2, dataField: "", colVisible: false, caption: "", dataType: "" },



    ]
  },
  {
    itemType: "group", groupWidth: 1000, class: "mt-2", groupDataField: 'indirizzoSedeLegale', colCount: "3", caption: "Indirizzo sede legale", data: [

      {
        type: 'campo',
        dataField: "indirizzo",
        class: "required",
        caption: "Indirizzo",
        dataType: "",
        showInColumnChooser: true,
        allowHiding: false,
        maxLength: '35',
        maxSize: 45,
        colVisible: true,
        orderGriglia: 3,
        colWidth: '177',
        nCol: 5,
        validation: [
          { type: "required", message: "Indirizzo obbligatorio" }
        ],
      },
      {
        type: 'campo', dataField: "civico", caption: "Nr.", dataType: "", colVisible: true,
        showInColumnChooser: true, allowHiding: false,
        orderGriglia: 4, colWidth: '60',
        nCol: "2",
        width: 50,
        labelWidth: 35,
        maxLength: '7',
        maxSize: 7,


      },
      { type: 'empty', nCol: "3", dataField: "", dataType: "", caption: "", colVisible: false },

      {
        type: 'campo', dataField: "frazione", caption: "Frazione", dataType: "", colVisible: false,
        maxLength: '45', maxSize: 45,
        colSpan: "3",
        nCol: 5,
      },
      {
        type: 'campoSpecial', dataField: "comune", caption: "Comune", dataType: "",
        maxLength: '42',
        maxSize: 40,
        colVisible: true,
        orderGriglia: 4,
        showInColumnChooser: true,
        allowHiding: false,
        allowEditing: true,
        colWidth: '300',
        nCol: "5",
        colSpan: 3,
        disableOnUpdate: false,
        validation: [
          { type: "required", message: "Comune obbligatorio" }
        ],
        dynamic: {
          service: 'comuneList',
          dataSource: 'comune',
          queryString: '',
          autocomplete: false,
          /*  checkValue: {
             checkValueMessage: 'Comune inesistente, vuoi continuare?',
             forceInsert: true
           }, */
          /* searchOptions: {
            api: 'comune',
            dataFieldToSearch: [
              { type: 'campo', dataField: "id", dataType: "string", caption: "ISTAT", colWidth: '55' },
              { type: 'campo', dataField: "descrizione", dataType: "", caption: "Comune", colWidth: '300' },
              { type: 'campo', dataField: "siglaProvincia", dataType: "string", caption: "PR.", colWidth: '40' },
              { type: 'campo', dataField: "cap", dataType: "string", caption: "CAP", colWidth: '70' },
            ],  //array di dati nei quali effetuare la ricerca oltre che a rappresentare a video il risultato della ricerca.
            dataFielToDisplay: ['descrizione'],  //array di dati da utilizzare nell'oggetto selezionato che verranno rappresentare a video nel campo.
            related: ['cap', 'siglaProvincia', 'id|istatComune'], // campi realzionati se diversi da quelli gia definiti dell'items

          }, */
          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Elenco comuni Italia",
          componentType: 'dynamicGrid',
          related: ['cap', 'siglaProvincia', 'id|istatComune'],
          buttonOption: {
            text: 'Comuni',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Comune',
            name: 'Comuni',
            location: 'after',
          },
          settingGrid:
            createGridConfig({
              ...gridSimple,
              searchType: 'startsWith',
              colonne: [
                { type: 'campo', dataField: "id", dataType: "string", caption: "ISTAT", colWidth: '55' },
                { type: 'campo', dataField: "descrizione", dataType: "", caption: "Comune", colWidth: '300' },
                { type: 'campo', dataField: "siglaProvincia", dataType: "string", caption: "PR.", colWidth: '40' },
                { type: 'campo', dataField: "cap", dataType: "string", caption: "Cap", colWidth: '70' },
              ]


            })






        }

      },



      {
        type: 'campo', dataField: "cap", caption: "Cap", dataType: "", colVisible: true,
        maxLength: '5', maxSize: 5,
        colWidth: '74',
        nCol: "25",
        width: 80,

      },
      {
        type: 'campoSpecial', dataField: "siglaProvincia", caption: "Provincia",
        nCol: 25,
        labelWidth: 75,
        editorType: "dxSelectBox", maxLength: "2",
        colVisible: true, colWidth: '88',
        showInColumnChooser: true,
        allowHiding: false,
        lista: {
          dataSource: 'provincia',
          valueExpr: 'siglaProvincia',
          displayExpr: 'descrizione',
          static: false,
        }
      },

      {
        showInColumnChooser: false,
        type: 'campo',
        width: 25,
        labelWidth: 35,
        dataField: "istatComune",
        dataType: "",
        caption: "Istat",
        colVisible: false,
        showClearButton: false,
        disableOnUpdate: true,
        nCol: "4",
      },
      {

        type: 'campoSpecial', colVisible: false, dataField: "stato", dataType: "", caption: "Stato",
        maxLength: '2', maxSize: 40, nCol: 3, colSpan: 3,
        validation: [
          { type: "required", message: "Stato obbligatorio" }
        ],
        lista: {
          dataSource: 'statoEstero',
          valueExpr: 'iso',
          displayExpr: 'descrizione',
          static: false
        },
        editorType: 'dxSelectBox'
      },



      {
        type: 'campoSpecial', colVisible: false, dataField: "idZona", dataType: "", caption: "Zona",

        labelVisible: true,
        disableOnUpdate: true,
        nCol: '5',
        colSpan: 3,
        dynamic: {
          costantValue: [{ key: 'nomeTabella', value: 'soggetti' }],
          dataSource: 'zona',
          service: 'generic',
          autocomplete: false,
          valueExpr: 'id',
          displayExpr: 'descrizione',
          caption: "Lista Zone",
          queryString: '?nomeTabella=soggetti',
          componentType: 'dynamicGrid',

          buttonOption: {
            text: 'Zone',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Zona',
            name: 'Zone',
            location: 'after',
          },
          settingGrid: gridEditable

        }

      },
      {
        type: 'campoSpecial', dataField: "idCategoria", dataType: "", caption: "Categoria",
        colSpan: 3,
        nCol: 5,
        disableOnUpdate: true,
        colVisible: false,
        dynamic: {
          costantValue: [{ key: 'nomeTabella', value: 'soggetti' }],
          dataSource: 'categoria',
          service: 'generic',
          autocomplete: false,
          valueExpr: 'id',
          displayExpr: 'descrizione',
          caption: "Lista Categorie",
          queryString: '?nomeTabella=soggetti',
          componentType: 'dynamicGrid',

          buttonOption: {
            text: 'Categoria',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Categoria',
            name: 'Categorie',
            location: 'after',
          },
          settingGrid: gridEditable

        }



      },

    ]
  },


]
